import React, { FC } from "react";
import styled from "styled-components";
import { ReactComponent as Search_icon } from "../../../assets/img/icons/search.svg";

interface IKeywordPillProps {
  keyword: string;
}
/**
 * * A component for showing the keywords in the preview article sidebar
 */
const KeywordPill: FC<IKeywordPillProps> = ({ keyword }) => {
  return (
    <>
      <KeywordCapsulWrapper>
        <div className="d-flex flex-nowrap">
          <span className="search-icon">
            <Search_icon />
          </span>
          <span className="item-label">{keyword}</span>
        </div>
      </KeywordCapsulWrapper>
    </>
  );
};

export default KeywordPill;

const KeywordCapsulWrapper = styled.div`
  border-radius: 15px;
  background: #e7edff;
  border: 1px solid #dadada;
  padding: 7px 18px 7px 10px;
  display: inline;
  float: left;
  transition: 0.5s;
  margin-top: 4px;
  margin-right: 7px;
  height: fit-content;
  margin: 4px 5px;
  text-transform: capitalize;
  max-width: 100%;
  .item-label {
    color: #001760;
    font-size: 14px;
    font-weight: 500;
    font-family: "robotobold";
    float: left;
    line-height: 16px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 12px;
    }
  }
  .search-icon {
    margin-right: 7px;
    padding-right: 7px;
    float: left;
    border-right: 1px solid rgb(218, 218, 218);
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      margin-right: 5px;
      padding-right: 5px;
    }
    svg {
      float: left;
    }
  }
`;
